<template>
	<div class="container">
		<h1>Electronic Press Kit</h1>
		<p>Media materials for the Barred Owl Stringband.</p>

		<h2>Booking Contact:</h2><p>barredowlband@gmail.com</p>
		<h2>Social Media:</h2>
		<p><strong>Facebook:</strong>
			<br>
			<a href="https://www.facebook.com/thebarredowlstringband">www.facebook.com/thebarredowlstringband</a>
		</p>
		<p><strong>Instagram:</strong>
			<br>
			<a href="https://www.instagram.com/barredowlstringband">@barredowlstringband</a>
		</p>
		<h2>Bio</h2>
		<p>Forged in the heart of Milwaukee’s Riverwest bluegrass community The Barred Owl Stringband performs Americana tunes rooted in the days of yore.</p>
		<h2 id="promo-photos">Promotional Images</h2>
		<p><a href="/assets/img/bosb-press-kit.zip">Download high-res images for event promotion</a></p>
		<h2 id="">Video</h2>
		<p>Video recordings of past event gigs.</p>
		<p><a href="https://www.youtube.com/watch?v=lGCax0QA24s">The Barred Owl Stringband performing, "Foggy Mountain Special".</a></p>
		<p><a href="https://www.youtube.com/watch?v=JcG-8iDXAUg&list=RDJcG-8iDXAUg&start_radio=1">The Barred Owl Stringband performing, "Love for the Mountains".</a>
		</p>
		<p>
		<a href="https://www.youtube.com/watch?v=LPEZ3GL6IAs&list=RDLPEZ3GL6IAs&start_radio=1">The Barred Owl Stringband performing, "Goldrush".</a>
		</p>
	</div>
</template>

<script>
	
	export default {
		name: "EPK",
		data() {
			
		},
		mounted(){
			
		},
		methods: {
			
		}
	};
</script>